import { EditOutlined, PoweroffOutlined } from '@ant-design/icons';
import { Button, Space, TablePaginationConfig } from 'antd';
import { FilterValue, SorterResult } from 'antd/es/table/interface';
import { Column, Table } from 'components';
import {
  StyledTableHeader,
  StyledTableWrapper,
} from 'components/table/table.styled';
import { getUserFullName, usePermissions } from 'features/users';
import { UserFilterFormValuesPaginated } from 'features/users/components/users-filter-form';
import { Dispatch, SetStateAction } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { ROUTES } from 'routes/constants';
import { getRoute } from 'routes/utils';
import { User } from 'types';

type UsersTableProps = {
  isUsersListLoading: boolean;
  usersList: User[];
  itemsCount: number;
  tableParams: UserFilterFormValuesPaginated;
  updateParams: Dispatch<SetStateAction<UserFilterFormValuesPaginated>>;
};

export const AssignTable = ({
  usersList,
  isUsersListLoading,
  itemsCount,
  tableParams,
  updateParams,
}: UsersTableProps) => {
  const { t } = useTranslation();
  const permissions = usePermissions();
  const navigate = useNavigate();
  if (!permissions) return null;
  const handleTableChange = (
    pagination: TablePaginationConfig,
    filters: Record<string, FilterValue | null>,
    sorter: SorterResult<User> | SorterResult<User>[],
  ) => {
    updateParams({
      ...tableParams,
      PageIndex: pagination.current,
      RecordPerPage: pagination.pageSize,
      order_by: Array.isArray(sorter)
        ? undefined
        : sorter.order === 'ascend'
        ? 'name'
        : '-name',
    });
  };

  return (
    <StyledTableWrapper>
      <StyledTableHeader></StyledTableHeader>
      <Table<User>
        loading={isUsersListLoading}
        dataSource={usersList}
        rowKey='id'
        onChange={handleTableChange}
        pagination={{
          current: tableParams.PageIndex,
          defaultPageSize: tableParams.RecordPerPage,
          total: itemsCount,
        }}
        onRow={(record) => {
          return {
            onClick: () => {
              const selection = window?.getSelection()?.toString();

              if (!selection?.length) {
                navigate(getRoute(ROUTES.USERS_ADMIN_EDIT, record.id));
              }
            },
          };
        }}
        components={{
          header: {
            cell: (props: React.HTMLAttributes<HTMLTableHeaderCellElement>) => (
              <th {...props} />
            ),
          },
        }}
      >
        <Column<User>
          title={t('assignedClient.table.clientId')}
          dataIndex={'customerName'}
          render={(_, record) => getUserFullName(record)}
        />
        <Column<User>
          title={t('assignedClient.table.clientName')}
          dataIndex={'user'}
        />
        <Column<User>
          title={t('assignedClient.table.clientEmail')}
          dataIndex={'user'}
        />
        <Column<User>
          title={t('assignedClient.table.businessName')}
          dataIndex={'user'}
          render={(_, record) => record.email}
        />
        <Column<User>
          title={t('assignedClient.table.assignedadmin')}
          dataIndex={'user'}
          render={(_, record) => record.phone_number}
        />
        <Column<User>
          title={t('assignedClient.table.subscriptiontype')}
          dataIndex={'user'}
        />
        <Column<User>
          title={t('assignedClient.table.LastUpdate')}
          dataIndex={'user'}
        />
        <Column<User>
          title={t('assignedClient.table.status')}
          dataIndex={'user'}
        />
        <Column<User>
          title={t('assignedClient.table.action')}
          dataIndex={'user'}
          render={() => (
            <Space>
              <Button
                type='link'
                color='default'
                style={{ backgroundColor: '#223666' }}
                icon={<EditOutlined />}
              />
              <Button type='primary' danger icon={<PoweroffOutlined />} />
            </Space>
          )}
        />
      </Table>
    </StyledTableWrapper>
  );
};
